// USA
export const locale = {
	lang: 'pt-BR',
	data: {
		TRANSLATOR: {
			SELECT: 'Selecione seu idioma',
		},
		MENU: {
			NEW: 'novo',
			ACTIONS: 'Ações',
			CREATE_POST: 'Cria Nova Postagem',
			REPORTS: 'Relatórios',
			APPS: 'Apps',
			DASHBOARD: 'Dashboard'
		},
		AUTH: {
			GENERAL: {
				OR: 'Ou',
				SUBMIT_BUTTON: 'Enviar',
				NO_ACCOUNT: 'Não tem uma conta?',
				SIGNUP_BUTTON: 'Inscreva-se',
				FORGOT_BUTTON: 'Esqueci minha senha',
				BACK_BUTTON: 'Voltar',
				PRIVACY: 'Privacidade',
				LEGAL: 'Termos de uso',
				CONTACT: 'Contato',
			},
			LOGIN: {
				TITLE: 'Faça login',
				BUTTON: 'Entrar',
			},
			FORGOT: {
				TITLE: 'Esqueceu sua senha?',
				DESC: 'Informe seu email para redefinir sua senha',
			},
			REGISTER: {
				TITLE: 'Inscrever-se',
				DESC: 'Digite suas informações para a criação de conta',
				SUCCESS: 'Sua conta foi registrada com sucesso. Por favor, user suas credenciais para realizar o login.'
			},
			INPUT: {
				EMAIL: 'Email',
				FULLNAME: 'Nome Completo',
				PASSWORD: 'Senha',
				CONFIRM_PASSWORD: 'Confirmar Senha',
			},
			VALIDATION: {
				INVALID: '{{name}} não é válido',
				REQUIRED: '{{name}} é necessário',
				MIN_LENGTH: '{{name}} minimum length is {{min}}',
				AGREEMENT_REQUIRED: 'Accepting terms & conditions are required',
				NOT_FOUND: 'The requested {{name}} is not found',
				INVALID_LOGIN: 'Email e/ou senha incorretos'
			}
		},
		ECOMMERCE: {
			COMMON: {
				SELECTED_RECORDS_COUNT: 'Selected records count: ',
				ALL: 'All',
				SUSPENDED: 'Suspended',
				ACTIVE: 'Active',
				FILTER: 'Filter',
				BY_STATUS: 'by Status',
				BY_TYPE: 'by Type',
				BUSINESS: 'Business',
				INDIVIDUAL: 'Individual',
				SEARCH: 'Search',
				IN_ALL_FIELDS: 'in all fields'
			},
			ECOMMERCE: 'eCommerce',
			CUSTOMERS: {
				CUSTOMERS: 'Customers',
				CUSTOMERS_LIST: 'Customers list',
				NEW_CUSTOMER: 'New Customer',
				DELETE_CUSTOMER_SIMPLE: {
					TITLE: 'Customer Delete',
					DESCRIPTION: 'Are you sure to permanently delete this customer?',
					WAIT_DESCRIPTION: 'Customer is deleting...',
					MESSAGE: 'Customer has been deleted'
				},
				DELETE_CUSTOMER_MULTY: {
					TITLE: 'Customers Delete',
					DESCRIPTION: 'Are you sure to permanently delete selected customers?',
					WAIT_DESCRIPTION: 'Customers are deleting...',
					MESSAGE: 'Selected customers have been deleted'
				},
				UPDATE_STATUS: {
					TITLE: 'Status has been updated for selected customers',
					MESSAGE: 'Selected customers status have successfully been updated'
				},
				EDIT: {
					UPDATE_MESSAGE: 'Customer has been updated',
					ADD_MESSAGE: 'Customer has been created'
				}
			}
		}
	}
};
